import React, { lazy } from 'react';
import { CheckCircle2, BookOpen } from 'lucide-react';
export function SolutionSection() {
  const tomos = [{
    id: 1,
    badge: 'EMPIEZA AQUÍ',
    title: 'TOMO 1: EL MERCADO INVISIBLE',
    desc: 'Descubre por qué las marcas necesitan gente como tú HOY y cómo funciona el mercado UGC en España.',
    bullets: ['Por qué el salario mediano en España hace imposible el ahorro', 'Cómo el UGC es la oportunidad de mayor demanda y menor saturación en 2024', 'Los 5 nichos de mayor inversión en España', 'La mentalidad que separa al creador que gana de al que abandona', 'Tu plan de acción de los primeros 30 días'],
    value: '47€'
  }, {
    id: 2,
    badge: 'SETUP TÉCNICO',
    title: 'TOMO 2: TU ESTUDIO POR 0€',
    desc: 'Convierte tu móvil y tu salón en un estudio de grabación profesional sin gastar un euro.',
    bullets: ['La configuración exacta de tu móvil (iOS y Android)', 'El método de la ventana: iluminación profesional por 0€', 'Audio: el secreto que nadie menciona y que marca la diferencia', 'Composición y encuadre en 5 reglas básicas', 'Edición mínima viable con apps gratuitas'],
    value: '47€'
  }, {
    id: 3,
    badge: 'EL CORAZÓN DEL SISTEMA',
    title: 'TOMO 3: EL VIDEO QUE VENDE',
    desc: 'La anatomía exacta del video UGC que las marcas no pueden rechazar.',
    bullets: ['La psicología de los 0,3 segundos que lo deciden todo', 'Los 5 bloques del guion perfecto (estructura probada)', '25 hooks de apertura listos para usar', 'El CTA invisible que convierte sin sonar a anuncio', '6 guiones completos palabra por palabra para 6 nichos'],
    value: '67€'
  }, {
    id: 4,
    badge: 'CONSIGUE CLIENTES',
    title: 'TOMO 4: EL RADAR DE MARCAS',
    desc: 'Localiza y contacta a las empresas españolas que pagan por UGC ahora mismo.',
    bullets: ['El mapa completo del ecosistema de marcas en España', 'Las 5 plataformas UGC donde registrarse hoy', 'Tu Media Kit profesional desde cero (plantilla incluida)', 'Prospección directa en Instagram, LinkedIn y TikTok', 'El sistema CRM para gestionar 20 contactos simultáneos'],
    value: '67€'
  }, {
    id: 5,
    badge: 'ESCALA',
    title: 'TOMO 5: DE 500€ A 2.000€',
    desc: 'El sistema de escala predecible para creadores UGC en España.',
    bullets: ['El modelo de retainer que genera ingresos predecibles', 'La subida de precios estratégica sin perder clientes', 'Las 6 fuentes de ingreso adicionales para diversificar', 'Automatización con IA para producir más en menos tiempo', 'El plan completo de 12 meses de 0€ a 2.000€'],
    value: '67€'
  }];
  return <section className="bg-white py-20 px-4" data-id="element-279">
      <div className="max-w-4xl mx-auto" data-id="element-280">
        <div className="text-center mb-10" data-id="element-281">
          <span className="text-neon font-bold text-sm tracking-widest uppercase bg-black px-4 py-1 rounded-full" data-id="element-282">
            — LA SOLUCIÓN —
          </span>
        </div>

        <h2 className="text-3xl md:text-5xl font-extrabold text-black text-center leading-tight mb-12 font-montserrat" data-id="element-283">
          "Presentando: El Sistema Completo para Ganar tus Primeros 500€ Extra
          al Mes con UGC en España"
        </h2>

        <div className="w-full max-w-3xl mx-auto mb-16 relative group cursor-pointer" onClick={() => document.getElementById('compra')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-284">
          <div className="absolute inset-0 bg-neon opacity-20 blur-3xl rounded-full group-hover:opacity-40 transition-opacity duration-500" data-id="element-285"></div>
          <img src="https://cdn.magicpatterns.com/uploads/bdih42FJdYugB6t1T9BLSt/mockup.png" alt="El Método 500€ Bundle" width={1400} height={768} loading="lazy" decoding="async" className="w-full h-auto relative z-10 drop-shadow-2xl transform group-hover:scale-105 transition-transform duration-500" data-id="element-286" />
        </div>

        <div className="text-lg text-gray-800 space-y-6 mb-16 text-center max-w-2xl mx-auto" data-id="element-287">
          <p data-id="element-288">
            <strong className="text-black text-xl" data-id="element-289">El Método 500€</strong> es la
            colección más completa de recursos en español para empezar a ganar
            dinero con el UGC desde cero.
          </p>
          <p data-id="element-290">No es un curso con horas de video que nunca terminas.</p>
          <p data-id="element-291">No es un grupo de Telegram lleno de teoría que no aplicas.</p>
          <p className="font-bold text-xl text-black bg-neon/20 p-4 rounded-lg" data-id="element-292">
            Son 5 manuales de acción directa que te llevan de la mano desde
            entender el mercado hasta cobrar tu primera factura.
          </p>
        </div>

        <div className="space-y-8 mb-16" data-id="element-293">
          {tomos.map(tomo => <div key={tomo.id} className="bg-gray-900 rounded-2xl border-2 border-neon p-6 md:p-10 shadow-neon-lg transform hover:-translate-y-1 transition-transform duration-300" data-id="element-294">
              <div className="inline-block bg-neon text-black font-black text-xs tracking-widest uppercase px-4 py-1 rounded-full mb-6" data-id="element-295">
                {tomo.badge}
              </div>

              <h3 className="text-2xl md:text-3xl font-black text-white mb-4 flex items-center gap-3" data-id="element-296">
                <BookOpen className="w-8 h-8 text-neon shrink-0" data-id="element-297" />
                {tomo.title}
              </h3>

              <p className="text-gray-300 italic mb-8 text-lg border-l-4 border-neon pl-4" data-id="element-298">
                {tomo.desc}
              </p>

              <ul className="space-y-4 mb-8" data-id="element-299">
                {tomo.bullets.map((bullet, idx) => <li key={idx} className="flex items-start gap-3 text-white" data-id="element-300">
                    <CheckCircle2 className="w-6 h-6 text-neon shrink-0 mt-0.5" data-id="element-301" />
                    <span className="text-lg" data-id="element-302">{bullet}</span>
                  </li>)}
              </ul>

              <div className="border-t border-gray-700 pt-6 mt-6" data-id="element-303">
                <p className="text-xl font-bold text-gray-400" data-id="element-304">
                  Valor Real: <span className="line-through" data-id="element-305">{tomo.value}</span>
                </p>
              </div>
            </div>)}
        </div>

        <div className="bg-neon rounded-2xl p-6 md:p-10 shadow-neon-lg border-4 border-black text-black max-w-2xl mx-auto mb-16" data-id="element-306">
          <h3 className="text-2xl md:text-3xl font-black text-center mb-8 uppercase tracking-tight border-b-4 border-black pb-4" data-id="element-307">
            VALOR TOTAL DEL SISTEMA:
          </h3>

          <div className="space-y-4 text-lg md:text-xl font-bold mb-8" data-id="element-308">
            <div className="flex justify-between items-center border-b border-black/20 pb-2" data-id="element-309">
              <span data-id="element-310">Tomo 1: El Mercado Invisible</span>
              <span data-id="element-311">47€</span>
            </div>
            <div className="flex justify-between items-center border-b border-black/20 pb-2" data-id="element-312">
              <span data-id="element-313">Tomo 2: Tu Estudio por 0€</span>
              <span data-id="element-314">47€</span>
            </div>
            <div className="flex justify-between items-center border-b border-black/20 pb-2" data-id="element-315">
              <span data-id="element-316">Tomo 3: El Video que Vende</span>
              <span data-id="element-317">67€</span>
            </div>
            <div className="flex justify-between items-center border-b border-black/20 pb-2" data-id="element-318">
              <span data-id="element-319">Tomo 4: El Radar de Marcas</span>
              <span data-id="element-320">67€</span>
            </div>
            <div className="flex justify-between items-center border-b border-black/20 pb-2" data-id="element-321">
              <span data-id="element-322">Tomo 5: De 500€ a 2.000€</span>
              <span data-id="element-323">67€</span>
            </div>
          </div>

          <div className="border-t-4 border-black pt-6" data-id="element-324">
            <div className="flex justify-between items-center text-xl md:text-2xl font-black text-gray-800 mb-2" data-id="element-325">
              <span data-id="element-326">VALOR TOTAL REAL:</span>
              <span className="line-through" data-id="element-327">295€</span>
            </div>
            <div className="flex justify-between items-center text-3xl md:text-5xl font-black mt-4 bg-black text-neon p-4 rounded-xl" data-id="element-328">
              <span data-id="element-329">TU PRECIO HOY:</span>
              <span data-id="element-330">17.99€ ✅</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}